import { 
  integrations, 
  // showManageModal kaldırıldı
  showGoogleStatusModal,
  // selectedIntegration kaldırıldı
  isLoading, 
  hasCheckedIntegration,
  sortedIntegrations,
  showOAuthLoading,
  currentPlatformId,
  oauthStatus,
  oauthErrorMessage
} from './state'
import { useI18n } from 'vue-i18n'
import { computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import useGoogleIntegration from '../use-google-integration'

import { toggleIntegration } from './methods/toggle-integration'
import { openManageModal } from './methods/open-manage-modal'
import { checkAuth } from './methods/check-auth'
import { handleOAuthResponse } from './methods/handle-oauth-response'
import { checkPendingIntegration } from './methods/check-pending-integration'

/**
 * Integration management composable for handling all integration-related operations
 */
export default function useIntegrationManagement() {
  // Tüm composable'lar setup fonksiyonu içinde çağrılmalı
  const { t } = useI18n()
  const router = useRouter()
  const route = useRoute()
  const { loadGoogleAccounts } = useGoogleIntegration()
  
  // Set up translations for integration descriptions
  integrations.value.forEach(integration => {
    const name = integration.name.toLowerCase()
    integration.description = computed(() => 
      t(`settings.components.integrations.${name}.description`)
    )
    integration.disabledTooltip = computed(() => 
      t(`settings.components.integrations.${name}.disabledTooltip`)
    )
  })

  // Metotlara parametre olarak verilecek fonksiyon wrapperları oluştur
  const handleOAuthResponseWrapper = (id, data) => {
    return handleOAuthResponse(id, data, t, router, loadGoogleAccounts)
  }

  const checkPendingIntegrationWrapper = () => {
    return checkPendingIntegration(route, handleOAuthResponseWrapper)
  }

  return {
    // State
    integrations,
    // showManageModal kaldırıldı
    showGoogleStatusModal,
    // selectedIntegration kaldırıldı
    isLoading,
    hasCheckedIntegration,
    sortedIntegrations,
    showOAuthLoading,
    currentPlatformId,
    oauthStatus,
    oauthErrorMessage,
    
    // Methods - wrapperlar içinde gerekli parametreleri geçiyoruz
    toggleIntegration: (id) => toggleIntegration(id, t, loadGoogleAccounts),
    openManageModal: (id) => openManageModal(id, loadGoogleAccounts),
    checkAuth: () => checkAuth(t),
    handleOAuthResponse: handleOAuthResponseWrapper,
    checkPendingIntegration: checkPendingIntegrationWrapper
  }
}